import React from 'react'
import { Icon } from '@chakra-ui/react'

export function IconSEOChecklist(rest) {
  return (
    <Icon viewBox="0 0 32 32" {...rest}>
      <g fillRule="evenodd" fill="currentColor" clipRule="evenodd">
        <path d="M14 7a1 1 0 0 0 0 2h12a1 1 0 0 0 0-2H14zm0-1h12a2 2 0 1 1 0 4H14a2 2 0 1 1 0-4zm0 17a1 1 0 0 0 0 2h12a1 1 0 0 0 0-2H14zm0-1h12a2 2 0 1 1 0 4H14a2 2 0 1 1 0-4zm0-7a1 1 0 0 0 0 2h12a1 1 0 0 0 0-2H14zm0-1h12a2 2 0 1 1 0 4H14a2 2 0 1 1 0-4z" />
        <path d="M5 7v2h2V7H5zm0-1h2a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1V7a1 1 0 0 1 1-1zM5 15v2h2v-2H5zm0-1h2a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1v-2a1 1 0 0 1 1-1zM5 23v2h2v-2H5zm0-1h2a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1v-2a1 1 0 0 1 1-1z" />
      </g>
    </Icon>
  )
}
